import { dehydrate, QueryClient } from 'react-query'

import MetaTags from 'components/MetaTags'
import ServicesPage from 'components/Services'
import { servicesMeta } from 'shared/constants'

import ServicesApi from 'api/ServicesApi'

export async function getServerSideProps() {
  const queryClient = new QueryClient()

  await Promise.all([
    queryClient.prefetchQuery(['services'], () => ServicesApi.list()),
    queryClient.prefetchQuery(['default-services-background'], () =>
      ServicesApi.getDefaultBackground(),
    ),
    queryClient.prefetchQuery(['auto-rotate-services-timer'], () =>
      ServicesApi.getAutoRotateTimer(),
    ),
  ])

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
  }
}

const Services = () => {
  return (
    <>
      <MetaTags data={servicesMeta} />
      <ServicesPage />
    </>
  )
}
export default Services
